import { range } from 'lodash';
import React, { FunctionComponent } from 'react';

import { ParagraphPlaceholder } from 'src/components/paragraph-placeholder';
import { i18n } from 'src/i18n';

import {
  StyledCard,
  StyledCardTitlePlaceholder,
  StyledImagePlaceholder,
  StyledInformationPlaceholder,
  StyledProductDescription,
  StyledProductPlaceholder,
  StyledProductsSummary,
  StyledSummaryPlaceholder,
  StyledText,
  StyledTitle,
} from './summary-page-placeholder.styled';

const SummaryPagePlaceholder: FunctionComponent = () => {
  const renderProductPlaceholder = (key: number) => (
    <StyledProductPlaceholder key={key}>
      <StyledImagePlaceholder />
      <StyledProductDescription>
        <ParagraphPlaceholder numberOfRows={2} />
      </StyledProductDescription>
    </StyledProductPlaceholder>
  );

  const renderInformationCard = (key: number) => (
    <StyledCard key={key}>
      <StyledInformationPlaceholder numberOfRows={2} hasTitle={true} />
    </StyledCard>
  );

  return (
    <>
      <StyledTitle variant="headline3" component="h1">
        {i18n.page.summary.placeholder.doNotCloseTheTab}
      </StyledTitle>
      <StyledText variant="paragraph1" component="p">
        {i18n.page.summary.placeholder.applicationIsSlow}
      </StyledText>
      <StyledCard>
        <StyledCardTitlePlaceholder />
        {range(2).map(renderProductPlaceholder)}
        <StyledProductsSummary>
          <StyledSummaryPlaceholder numberOfRows={2} />
        </StyledProductsSummary>
      </StyledCard>
      {range(2).map(renderInformationCard)}
    </>
  );
};

export { SummaryPagePlaceholder };
